import { useRef } from "react";

export interface ItemFocus {
  /** Ref callback for the row at `index` of the panel's items. */
  refFor: (index: number) => (el: HTMLDivElement | null) => void;
  element: (index: number) => HTMLDivElement | null;
  focusItem: (index: number | undefined) => void;
  /** Position within `interactive` of the focused row, or -1. */
  focusedPosition: (interactive: number[]) => number;
}

/** Keeps the panel's row elements to move focus between them. */
export function useItemFocus(): ItemFocus {
  const rows = useRef<(HTMLDivElement | null)[]>([]);
  return {
    refFor: (index) => (el) => {
      rows.current[index] = el;
    },
    element: (index) => rows.current[index] ?? null,
    focusItem: (index) => {
      if (index === undefined) return;
      rows.current[index]?.focus({ preventScroll: false });
    },
    focusedPosition: (interactive) => {
      const active = document.activeElement;
      return interactive.findIndex((index) => rows.current[index] === active);
    },
  };
}
